<template>

<div class="row" id='result-loader'>

    <div class='col-12' v-if='total == 0'>
        <div class="alert alert-info">
            <div class="alert-icon">
                <span class="icon icon-poker-face"></span>
            </div>
            <div class="d-flex justify-content-between align-items-center w-100">
                <div>
                    <span class="text-bold d-block">Sorry!</span>
                    <span class="text-small">No AI tools found in this search</span>
                </div>
                <!-- <button @click='clearFilters' class='btn btn-primary'>Clear filters</button> -->
                <a href="/" class='btn btn-primary'>Clear filters</a>
            </div>
        </div>
    </div>

    <div v-for='r in results' :key='r.url' class="col-12 col-sm-6 col-lg-4 mb-4">
        <div class='tool-box'>

            <a :href='"/tools/" + r.url' class="tb-img">
                <img :src=" _tools.toolImage(r,true)" class="img-fluid">

                <span v-if="r.cost && r.cost != 0" class="t-price"> {{ r.cost }} </span>
                <span v-else class="t-price"> Free </span>
            </a>

            <div class="tbox-content p-4">
                
                <div>
                    <h4>{{ r.title }}</h4>
                    <p>
                        {{ r.info.substring(0, 100) }}
                    </p>

                    <div v-if='r.tags' class="mb-4">
                        <span class='tag text-gradient' v-for='t in r.tags.split(",")'> #{{ t }} </span>
                    </div>
                </div>

                <div class="fav-listing text-sm-left text-md-center">
                    <a :href='"/tools/" + r.url' class="btn btn-primary">
                        Learn More
                    </a>

                    <fav-btn m='r->id' :l='r.likes' p='listing'></fav-btn> 
                </div>

            </div>
        </div>
    </div>

    <div class="col-12 my-3" v-if='total' id='load-more'>
        <div class="d-flex align-items-center justify-content-center">
            <span>
                {{ loaded }} / {{ total }} Loaded
            </span>

            <button class='btn btn-primary ml-3' @click='loadMore' v-if='loaded < total' :disabled='isLoading'>
                <span v-if='!isLoading'>Load More</span>
                <img v-if='isLoading' src='/resources/loader.svg' width="24px">
            </button>  
        </div>
        
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

            bus.$on('filter-tools', (conf) => {
                this.filterResults( conf );
            })

            setTimeout( () => {
                if( this.loaded < this.total ) {
                    this.initObserver();
                }
            },1250)

        },

        props : ['c','t','l'],

        created() {
            if( typeof this.c != 'undefined' ) {
                this.conf.cat = parseInt(this.c);
                this.cleanConf.cat = parseInt(this.c);
            }

            this.total = parseInt( this.t );
            this.loaded = parseInt( this.l );

            if( this.total < this.loaded ) {
                this.loaded = this.total;
            }

        },

        data() { 
            var me = this;

            return {
                isReady : false,
                isLoading : false,
                forObserve : 'load-more',
                results : [],

                conf : {
                    take : me.l,
                    cat : null
                },

                lastOffset : 0,

                cleanConf : {
                    take : me.l,
                    cat : null,
                    skip : 0,
                    tags : [],
                    search : null,
                },

                firstObserve : true,

                total : 0,
                loaded : 0,

                observer : false,
                obInit : false
            }
            
        },

        methods : {

            loadMore() {
                if( this.loaded >= this.total ) {
                    return;
                }

                this.lastOffset = window.pageYOffset;
                this.isLoading = true;

                this.conf.skip = this.loaded;

                this.ajax.call('tl:gl', this.conf, (r) => {
                    if( r.status == 'success' ) {

                        this.results = this.results.concat( r.data.results );
                        this.loaded += r.data.results.length;

                        this.isLoading = false;

                        this.$nextTick( () => {
                            $(window).scrollTop( this.lastOffset );
                        })

                    }
                })
            },

            filterResults( conf ) {
                $("#tl-holder").remove();

                this.isLoading = true;

                if( typeof conf == 'object' ) {
                    this.conf = Object.assign({}, this.conf, conf );
                }
                
                this.conf.skip = 0;

                this.ajax.call('tl:gl', this.conf, (r) => {
                    if( r.status == 'success' ) {
                        this.results = r.data.results;
                        this.total   = r.data.total;
                        this.loaded  = this.results.length;

                        bus.$emit('total-change', r.data.total);

                        this.isLoading = false;
                    }
                })

            },

            initObserver() {
                let target = document.getElementById(this.forObserve);

                if( !target ) {
                    return;
                }
                
                let options = {
                  // root: document.getElementById('lcs'),
                  rootMargin: '100px',
                  threshold: 1
                }

                var me = this;

                this.observer = new IntersectionObserver( (e) => { 
                    if( !e[0].isIntersecting ) {
                        return;
                    }

                    me.loadMore();

                 } , options);

                this.observer.observe(target);             
            },

            clearFilters() {
                this.conf = Object.assign({}, this.cleanConf);
                this.total = parseInt( this.t );
                this.loaded = 0;

                bus.$emit('filter-reset');

                this.filterResults();
            }
        }

    }
</script>
